import { type StoryObj } from "@storybook/react";

import type { FileItemType } from "$/lib/types/FileUploader.types";
import type FileUploader from "./FileUploader";
import type { HTMLAttributes } from "react";

export type FileUploaderProps = {
  name: string;
  className?: HTMLAttributes<HTMLDivElement>["className"];
  files?: (Omit<FileItemType, "id"> & { id?: string })[];
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onDragChange?: (event: React.DragEvent<HTMLLabelElement>) => void;
  onCancel?: (file: FileItemType) => void;
  onDelete?: (file: FileItemType) => void;
};

export const FileUploaderStatus = {
  UPLOADING: "uploading",
  COMPLETED: "completed",
  FAILED: "failed",
} as const;

export type FileUploaderStatus =
  (typeof FileUploaderStatus)[keyof typeof FileUploaderStatus];

export type FileItemProps = {
  file: File;
  currentUploadedSize: number;
  status?: FileUploaderStatus;
  onCancel?: VoidFunction;
  onDelete?: VoidFunction;
};

export type FileUploaderContentProps = {
  dragging?: boolean;
};

export type FileUploaderStory = StoryObj<typeof FileUploader>;
